import type { PluginManifest } from "@d12labs/plugins/types";

export const manifest: PluginManifest = {
	name: "uploads",
	label: "Uploads",
	description: "File uploads via Bun.s3 — demonstrates the chassis storage primitive.",
	version: "0.1.0",
	navItems: [{ label: "Uploads", href: "/uploads", icon: "Upload" }],
};
